var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg_(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3047 16.3461C13.1936 16.3715 12.8469 16.2868 12.5619 16.1648C11.7562 15.8107 10.9627 15.4071 10.1933 14.9044C8.5434 13.9244 6.86817 12.8333 5.24246 11.7542C4.32452 11.2153 3.40657 10.6764 2.50071 10.0879C1.55742 9.43784 0.860584 8.63802 0.533429 7.6136C0.142329 6.20625 0.308085 4.88235 1.39062 3.8872C2.0793 3.21571 2.84401 2.87763 3.68242 2.45259C4.92911 2.07475 6.10094 1.57367 7.3102 1.13422C8.38415 0.819153 9.40857 0.491998 10.4583 0.275981C11.3353 0.122745 12.1628 -0.0425822 13.0301 0.274078C14.9748 0.906232 15.0734 3.0818 14.1515 4.06369C13.7093 4.58544 13.1053 4.91027 12.5507 5.24718C11.7739 5.63478 10.9102 5.94868 9.99807 6.46068C9.70209 6.59833 9.66583 6.7469 10.0258 6.99219C10.9074 7.67969 11.7891 8.3672 12.6708 9.05471C13.7264 9.88963 14.8194 10.7862 15.5307 11.9568C15.7553 12.3265 16.0052 12.8073 16.1187 13.2023C16.4868 14.9189 15.2217 16.4468 13.3047 16.3461Z",
    fill: "#02004B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/_.a96019ef.svg";
export { ForwardRef as ReactComponent };